import React, { Component } from 'react'
import ButtonGroup from 'react-bootstrap/lib/ButtonGroup'
import Button from 'react-bootstrap/lib/Button'

class TeamDashButtonGroup extends Component {
    constructor(props) {
        super(props)
    }

    onTagClick = () => {
        this.props.onDisplayChange('tag')
    }

    onMemberClick = () => {
        this.props.onDisplayChange('member')
    }

    render() {
        const { display } = this.props
        return (
            <ButtonGroup>
                <Button onClick={this.onTagClick} active={display === 'tag'}>
                    Tag
                </Button>
                <Button onClick={this.onMemberClick} active={display === 'member'}>
                    Member
                </Button>
            </ButtonGroup>
        )
    }
}

export default TeamDashButtonGroup


// WEBPACK FOOTER //
// ./src/components/team_dash_button_group.jsx